import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { RootErrorBoundary } from './components/RootErrorBoundary'
import './styles.css'
import './planner.css'
import './planner-interactions.css'
import './workspace-safe.css'
import './workspace-layout.css'
import './workspace-v2.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootErrorBoundary area="основное приложение">
      <App />
    </RootErrorBoundary>
  </StrictMode>,
)
